import { render, staticRenderFns } from "./FileDetailLayout.vue?vue&type=template&id=64e25fc8&"
import script from "./FileDetailLayout.vue?vue&type=script&lang=ts&"
export * from "./FileDetailLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports